export const Unknown = ({ objectKind }: any) => {
  return <div>UNKNOWN COMPONENT, objectKind: {objectKind}</div>
}
